module.exports = __webpack_public_path__ + "img/exit_hover.503c98ff.png";